import { MapContainer, TileLayer, CircleMarker } from "react-leaflet";
import { useInView } from "react-intersection-observer";
import "leaflet/dist/leaflet.css";
import PropTypes from "prop-types";
import { getSewStatusColor } from "../utils/Utils";

/**
 * A compact Leaflet locator map that plots a single marker at the given
 * latitude/longitude.
 *
 * The map is non-interactive (it's a thumbnail, not a slippy map) and is only
 * mounted once it scrolls into view, so a long list of cards doesn't spin up
 * many map instances and tile requests at once.
 */
const SewMiniMap = ({ latitude, longitude, status, height = 150 }) => {
    const lat = parseFloat(latitude);
    const lon = parseFloat(longitude);
    const hasFix = Number.isFinite(lat) && Number.isFinite(lon);
    const { color: statusColor } = getSewStatusColor(status);

    const { ref, inView } = useInView({ triggerOnce: true, rootMargin: "200px" });

    const wrapperStyle = {
        width: "100%",
        height: `${height}px`,
        borderTopLeftRadius: "5px",
        borderTopRightRadius: "5px",
        overflow: "hidden",
        backgroundColor: "#11202b"
    };

    if (!hasFix) {
        return (
            <div
                style={{
                    ...wrapperStyle,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#ffffff66",
                    fontSize: "0.8rem"
                }}
            >
                No location data
            </div>
        );
    }

    return (
        <div ref={ref} style={wrapperStyle}>
            {inView && (
                <MapContainer
                    center={[lat, lon]}
                    zoom={3}
                    style={{ width: "100%", height: "100%" }}
                    dragging={false}
                    scrollWheelZoom={false}
                    doubleClickZoom={false}
                    touchZoom={false}
                    boxZoom={false}
                    keyboard={false}
                    zoomControl={false}
                >
                    <TileLayer
                        url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
                        attribution="&copy; OpenStreetMap contributors &copy; CARTO"
                        subdomains="abcd"
                    />
                    <CircleMarker
                        center={[lat, lon]}
                        radius={7}
                        pathOptions={{
                            color: "#ffffff",
                            weight: 1.5,
                            fillColor: statusColor,
                            fillOpacity: 0.9
                        }}
                    />
                </MapContainer>
            )}
        </div>
    );
};

SewMiniMap.propTypes = {
    latitude: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    longitude: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    status: PropTypes.string,
    height: PropTypes.number
};

export default SewMiniMap;
